import * as React from "react";
import { PropertyHelper } from "../../../../shared/utility/property-helper";
import KuikaSwitch from "../../../ui-kit/kuika-switch/kuika-switch";

export interface IPropertyFormSwitchPropertyState {
  value: boolean;
}

export interface IPropertyFormSwitchPropertyProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  dataTestId?: string;
}

export class PropertyFormSwitchProperty extends React.PureComponent<
  IPropertyFormSwitchPropertyProps,
  IPropertyFormSwitchPropertyState
> {
  propertyHelper: PropertyHelper;

  constructor(props) {
    super(props);
    this.propertyHelper = new PropertyHelper();
    this.state = {
      value: this.props.value
    };
  }

  componentDidUpdate = (prevProps: IPropertyFormSwitchPropertyProps) => {
    if (prevProps === this.props) return;
    this.setState({ value: this.props.value });
  };

  handleChangeValue = (value: boolean): void => {
    this.setState({ value }, () => {
      if (this.props.onChange) {
        this.props.onChange(value);
      }
    });
  };

  render(): React.ReactNode {
    return (
      <div className="kuika_switch_property">
        <KuikaSwitch
          onChange={this.handleChangeValue}
          checked={Boolean(this.state.value)}
          labelPosition="none"
          disabled={this.props.disabled}
          dataTestId={this.props.dataTestId}
        />
      </div>
    );
  }
}
